// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"531a96e5","453":"6049f281","790":"ac7a7959"}[chunkId] + ".chunk.js";
};